module.exports = __webpack_public_path__ + "static/media/fenqihudadongshan_plant.f106169a.png";